export default __webpack_public_path__ + "static/media/finn-min-lokasjon.12b33bea.svg";